import create from "zustand";

export interface CustomerFields {
    nameRequired: boolean | null;
    emailRequired: boolean;
    phoneRequired: boolean;
    customerName: string;
    customerEmail: string;
    showCustomerFields: boolean | null;
    isSameAsRecipient: boolean;
    phone: string;
    actions: {
        initialize: (customerName: string, customerEmail: string, phone: string) => void;
        resetState: () => void;
        setCustomerName: (customerName: string) => void;
        setCustomerEmail: (customerEmail: string) => void;
        setPhone: (phone: string) => void;
        setNameRequired: (nameRequired: boolean | null) => void;
        setEmailRequired: (emailRequired: boolean) => void;
        setPhoneRequired: (phoneRequired: boolean) => void;
    };
}

const defaultState = {
    nameRequired: null,
    emailRequired: true,
    phoneRequired: true,
    customerName: "",
    customerEmail: "",
    phone: "",
    showCustomerFields: null,
    isSameAsRecipient: false,
};

export const useCustomerDetailsStore = create<CustomerFields>((set) => ({
    ...defaultState,
    actions: {
        initialize: (customerName: string, customerEmail: string, phone: string) => {
            set({ customerName, customerEmail, phone });
        },

        resetState: () => set(defaultState),

        setCustomerName: (customerName: string) => set({ customerName }),

        setCustomerEmail: (customerEmail: string) => set({ customerEmail }),

        setPhone: (phone: string) => set({ phone }),

        setNameRequired: (nameRequired: boolean | null) => set({ nameRequired }),

        setEmailRequired: (emailRequired: boolean) => set({ emailRequired }),

        setPhoneRequired: (phoneRequired: boolean) => set({ phoneRequired }),
    },
}));
